import React from "react";

class DownloadButtons extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div
          className={"action-btns mt-3 d-flex flex-row ".concat(
            this.props.center === true ? "justify-content-center" : ""
          )}
        >
          <a
            href="https://play.google.com/store/apps/details?id=com.anthemav.control.anthem"
            className="d-flex flex-column align-items-center p-1"
          >
            <img
              src="img/download-google-play-store-logo.png"
              width="211px"
              alt="Get it on Google Play"
              className="img-fluid"
            ></img>
            <i>Anthem App Version 3.2.2</i>
          </a>

          <a
            href="https://apps.apple.com/us/app/anthem-remote/id1132341848"
            className="d-flex flex-column align-items-center p-1"
          >
            <img
              src="img/download-app-store-logo.png"
              width="189px"
              alt="Download on the App Store"
              className="img-fluid"
            ></img>
            <i>Anthem App Version 3.2.2</i>
            {/* <i>(Testflight required)</i> */}
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default DownloadButtons;
